import { sdReleaseNoteSplash } from "./splash/sd-release-note-splash";
import { sdReleaseNoteSplashContent } from "./splash/sd-release-note-splash-content";
import { sdReleaseNoteRollback } from "./rollback/sd-release-note-rollback";
import { sdDetailedReleaseNotes } from "./detail/sd-release-note-detail";
import { sdDetailedReleaseNotesContent } from "./detail/sd-release-note-detail-content";

let releaseNotesModule: ng.IModule = angular
  .module("sdApp.ReleaseNotes", [])
  .component("sdReleaseNoteSplash", sdReleaseNoteSplash)
  .component("sdReleaseNoteSplashContent", sdReleaseNoteSplashContent)
  .component("sdReleaseNoteRollback", sdReleaseNoteRollback)
  .component("sdDetailedReleaseNotes", sdDetailedReleaseNotes)
  .component("sdDetailedReleaseNotesContent", sdDetailedReleaseNotesContent);

export default releaseNotesModule;
